﻿import {JSX, MouseEvent, MouseEventHandler, ReactNode, useMemo} from "react";
import {ButtonKind} from "../ButtonKind";
import buttonTypeClass from "../helpers/buttonTypeClass";

export type ButtonProps = {
	children?: ReactNode,
	kind?: ButtonKind,
	waiting?: boolean,
	small?: boolean,
	onClick?: MouseEventHandler,
	disabled?: boolean,
};

function checkDisabled(e: MouseEvent<HTMLButtonElement>, userOnClick: MouseEventHandler | undefined) {
	if (e.currentTarget?.getAttribute('aria-disabled') === 'true') {
		e.preventDefault();
		e.stopPropagation();
		return;
	}

	if (userOnClick) userOnClick(e);
}

export default function Button({children, kind, waiting, small, onClick, disabled}: ButtonProps): JSX.Element {
	const isDisabled = disabled || waiting;
	const klass = useMemo(() => buttonTypeClass(kind) + (small ? " form__button--small" : ""), [kind, small]);

	return <button
				type={kind == "primary" ? 'submit' : 'button'}
				className={klass}
				aria-disabled={isDisabled}
				onClick={(e) => checkDisabled(e, onClick)}
				disabled={false}>
					{children}
					{waiting && <progress className="waiting"></progress>}
	</button>;
};
